import { render, staticRenderFns } from "./RecipeInformation.vue?vue&type=template&id=b05f8dbe&scoped=true&"
import script from "./RecipeInformation.vue?vue&type=script&lang=ts&"
export * from "./RecipeInformation.vue?vue&type=script&lang=ts&"
import style0 from "./RecipeInformation.vue?vue&type=style&index=0&id=b05f8dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05f8dbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VForm,VTextField,VTextarea})
